export const ADD_USER_DECISION = "ADD_USER_DECISION";
export const CHANGE_CURRENT_DECISION = "CHANGE_CURRENT_DECISION";
export const ADD_DECISION_COST_VARIABLES = "ADD_DECISION_COST_VARIABLES";
